require("./style.css");
import React from "react";
import PieChartTable from "../distribution/PieChartTable";
import AcquireWebComponent from "../../framework/MaterialUI";

class DeviceInsights extends AcquireWebComponent {
  render() {
    const { deviceModelData, deviceTypeData, top5OSBreakDown } = this.props;

    return (
      <div>
        <div className="mt-20" style={{ display: "flex" }}>
          <div style={{ flex: "50%" }}>
            <div className="light-grey-border mb-10" id="device-pdf-part1">
              {deviceTypeData && (
                <PieChartTable
                  data={deviceTypeData.values}
                  showUniqVisitsTitle={true}
                  dataKey="value"
                  title={"Device Breakdown"}
                  tableTitle={deviceTypeData.name}
                />
              )}
            </div>
            <div className="light-grey-border" id="device-pdf-part2">
              {deviceModelData && (
                <PieChartTable
                  data={deviceModelData.values}
                  showUniqVisitsTitle={true}
                  dataKey="value"
                  title={"Model Breakdown"}
                  tableTitle={deviceModelData.name}
                />
              )}
            </div>
          </div>
          <div style={{ flex: "20px" }} />
          <div style={{ flex: "50%" }}>
            <div className="light-grey-border" id="device-pdf-part3">
              {top5OSBreakDown && (
                <PieChartTable
                  data={top5OSBreakDown.values}
                  showUniqVisitsTitle={true}
                  dataKey="value"
                  title={"OS Breakdown"}
                  tableTitle={top5OSBreakDown.name}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DeviceInsights;



// WEBPACK FOOTER //
// ./src/components/Insights/website/Device.jsx